import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { applyTheme, ThemeMode } from './tokens';

interface ThemeCtx { mode: ThemeMode; setMode: (m: ThemeMode) => void; toggle: () => void; }

const Ctx = createContext<ThemeCtx | null>(null);
const STORAGE_KEY = 'crm.mode';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setModeState] = useState<ThemeMode>(() => (localStorage.getItem(STORAGE_KEY) as ThemeMode | null) ?? 'light');

  useEffect(() => { applyTheme(mode); localStorage.setItem(STORAGE_KEY, mode); }, [mode]);

  const value = useMemo<ThemeCtx>(() => ({
    mode,
    setMode: setModeState,
    toggle: () => setModeState(m => m === 'light' ? 'dark' : 'light'),
  }), [mode]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useTheme = (): ThemeCtx => {
  const v = useContext(Ctx);
  if (!v) throw new Error('useTheme must be used within ThemeProvider');
  return v;
};
